export const STORAGE_KEYS = {
  localUser: 'localUser',
  email: 'email',
  orgao: 'orgao',
  user: 'user',
  param: 'param'
}
